module.exports = __webpack_public_path__ + "static/media/bang4.de5bca61.mp3";